<div class="modal-body">
  <h2 class="modal-title">Lägg till skogsvård</h2>

  @for (row of skogsvard.skogsvardRowTypes; track row; let i = $index) {
    <rask-skogsvard-create-row
      (deleted)="delete($event)"
      [index]="i"
      [rowType]="row"
      [allSkogsvardGrupp]="skogsvardGrupper"
      [canDelete]="skogsvard.skogsvardRowTypes.length > 1"
      [isSkogsvardKontrakt]="isSkogsvardKontrakt">
    </rask-skogsvard-create-row>
  }


  <div class="d-flex add-skogsvard-row-container">
    <rask-action-button
      aid="buttonCreateSkogsvardRow"
      icon="far fa-plus"
    (click)="addSkogsvardRow()">Lägg till ytterligare skogsvård</rask-action-button>
  </div>

  <div class="hr-div">
    <hr>
    </div>

    <div class="pb-3">
      <rask-search
        aid="skogsvardSokKontrakt"
        col="col-12"
        label="Välj kontrakt att hämta om skogsvården ska utgå från befintlig yta"
        placeholder="Sök på kontrakt"
        bindLabel="namn"
        bindValue="kod"
        typeToSearchText="Ange minst tre tecken"
        loadingText="Laddar..."
        notFoundText="Ingen träff"
        [minTermLength]="3"
        [typeaheadFn]="searchForKontraktForSkogsvardsAtgarderTypeAhead"
        [selected]="preSelectedKontraktGuid"
        (selectedChanged)="selectedKontraktChanged($event)">
      </rask-search>
    </div>

    <div class="d-flex skogsvard-select-atgard-container">
      <div id="skogsvard-select-atgard" class="p-2 flex-fill">
        <rask-skogsvard-select-atgard
          [listOfAtgarder]="listOfAtgarder"
          [selectedAtgardGuid]="preSelectedAtgard"
          [isAtgardRequired]="false"
          [showCopyGeometries]="shouldShowCopyContractGeometries()"
          (selected)="skogsvardAtgardChanged($event)"
          (shouldCopyContractGeometries)="shouldCopyContractGeometriesChanged($event)"></rask-skogsvard-select-atgard>
      </div>
    </div>

    <div class="d-flex justify-content-end" id="skogsvard-create-end-row">
      <rask-button color="primary" [disabled]="!canSave()" (click)="save()">Skapa skogsvård</rask-button>
      <rask-button color="secondary" (click)="close()">Avbryt</rask-button>
    </div>
  </div>